import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';

import { loadWidgets, setWidgets } from '../actions';
import WidgetList from '../../editor/components/WidgetList';

import { withPortfolioWidgets } from '../hoc/widgets';

import { TABS, GROUP_KEY, ALL_WIDGETS } from '../constants';

import LeagueOverview from '../containers/LeagueOverview';
import TeamOverview from '../containers/TeamOverview';
import EventOverview from '../containers/EventOverview';
import PlayerOverview from '../containers/PlayerOverview';
import AllWidgetsOverview from '../containers/AllWidgetsOverview';

import Navigator from '../components/Navigator';

const PortfolioWidgets = withPortfolioWidgets(WidgetList);

const WidgetListPanel = ({ wide, tab, params, template, onTabOpen, onWidgetSelected }) => {
    params.wide = wide;
    params.tab = tab;

    return (
        <div style={{}}>
            <Navigator
                {...params}
                onLeagueSelected={tournamentId => {
                    onTabOpen('league', {
                        tournamentId,
                        teamId: null,
                        playerId: null,
                        eventId: null,
                    });
                }}
                onEventSelected={(eventId, ctx = {}) => {
                    onTabOpen('event', {
                        ...{
                            tournamentId: params.tournamentId, // ?
                            teamId: null,
                            playerId: null,
                            eventId,
                        },
                        ...ctx,
                    });
                }}
                onPlayerSelected={(teamId, playerId) => {
                    onTabOpen('player', {
                        tournamentId: params.tournamentId, // ?
                        teamId,
                        playerId,
                        eventId: null,
                    });
                }}
                onTeamSelected={(tournamentId, teamId) => {
                    onTabOpen('team', {
                        tournamentId,
                        teamId,
                        playerId: null,
                        eventId: null,
                    });
                }}
            />
            <div style={{ padding: 25 }}>
                {tab == TABS.ALL && (
                    <AllWidgetsOverview key={template} template={template} onClick={onWidgetSelected} />
                )}
                {tab == TABS.LEAGUE && (
                    <LeagueOverview
                        groupBy="category"
                        template={template}
                        wdpcache="state"
                        {...params}
                        onLeagueSelected={tournamentId => {
                            onTabOpen('league', {
                                tournamentId,
                            });
                        }}
                        onTeamSelected={teamId => {
                            onTabOpen('team', {
                                teamId,
                            });
                        }}
                        onClick={onWidgetSelected}
                    />
                )}

                {tab == TABS.PLAYER && (
                    <PlayerOverview
                        groupBy="category"
                        template={template}
                        wdpcache="state"
                        {...params}
                        onClick={onWidgetSelected}
                    />
                )}

                {tab == TABS.TEAM && (
                    <TeamOverview
                        groupBy="category"
                        template={template}
                        wdpcache="state"
                        {...params}
                        onClick={onWidgetSelected}
                    />
                )}

                {tab == TABS.EVENT && (
                    <EventOverview
                        groupBy="category"
                        template={template}
                        wdpcache="state"
                        {...params}
                        onClick={onWidgetSelected}
                    />
                )}

                {tab == 'portfolio' && (
                    <PortfolioWidgets
                        groupBy="category"
                        template={template}
                        wdpcache="state"
                        {...params}
                        onClick={onWidgetSelected}
                    />
                )}
            </div>
        </div>
    );
};

export default WidgetListPanel;



/** WEBPACK FOOTER **
 ** ../src/dash/front/widget-picker/components/WidgetListPanel.js
 **/